export const WYOnExchangeStatusTeamsite = {
  heading: 'CUSTOMER SHOPPING STATUS',
  noResultsMessage: 'There are no applications to display.',
  sidebar: {
    header: 'CUSTOMER SHOPPING STATUS',
    subText: 'Review information about customer application status.'
  },
  newCustomerStatusMessage:
    'Continue with your application to the Health Insurance Marketplace or Shop Directly with BCBSWY.<br><br>Plans purchased directly with BCBSWY are not eligible for the Advanced Premium Tax Credit (APTC) and/or Cost-Sharing Reduction (CSR).<br><br>',
  eligibilityMessage:
    'It looks like there is an error in determining your customer\'s Health Insurance Marketplace eligibility. Return to the Health Insurance Marketplace to resolve this issue, or continue to shop directly with BCBSWY. <br><br>Plans purchased directly from BCBSWY are not eligible for the Advanced Premium Tax Credit (APTC) and/or Cost-Sharing Reduction (CSR).<br><br>',
  userInitiatedReturnMessage:
    'You have returned without completing your customer\'s Health Insurance Marketplace eligibility application. To continue, select Go To the Marketplace. Or, you can Shop Directly with BCBSWY. <br><br>Plans purchased directly from BCBSWY are not eligible for the Advanced Premium Tax Credit (APTC) and/or Cost-Sharing Reduction (CSR).<br><br>',
  EligibilityCompleteMessage:
    'View your customer\'s Health Insurance Marketplace application results to find out if they are eligible for an Advanced Premium Tax Credit (APTC) and/or Cost-Sharing Reduction (CSR) to help with their health insurance costs.<br><br>',
  enrollmentSubmissionFailMessage:
    'We\'re sorry. Enrollment cannot be completed at this time.  In order to proceed, Go To the Health Insurance Marketplace and retrieve eligibility to try again.<br><br>',
  paymentPastDueMessage:
    'No payment was submitted with this online application.<br><br>Information displayed here does not reflect any payment made outside of this online application.<br>Click <b>More Info</b> to see more information and options.</br>',
  paymentPastDueSMABMessage:
    'No payment was submitted with this online application.<br><br>Information displayed here does not reflect any payment made outside of this online application.<br>Click <b>More Info</b> to see more information and options',
  paymentStatusModal: {
    header: 'More Info',
    body:
      'To see if payment has been made and to determine what payment options are available for this plan if payment was not made, contact the Producer Hotline at  1-866-602-1248  (TTY/TDD: 711) Monday thru Friday   8:00 a.m. – 5:00 p.m. EST'
  },
  goToMarketPlaceModal: {
    header: 'YOU ARE ABOUT TO VISIT THE HEALTH INSURANCE MARKETPLACE',
    body:
      'This website contains links to third-party websites and resources (collectively, "Linked Sites").  These Linked Sites are provided solely as a convenience to you and not as an endorsement by Highmark Inc., or its affiliates and subsidiaries, (collectively, “Highmark”) of the content on such Linked Sites. Highmark makes no representations or warranties regarding the correctness, accuracy, performance or quality of any content, software, service or application found at any Linked Site. Highmark is not responsible for the availability of the Linked Sites or the content or activities of such sites. If you decide to access Linked Sites, you do so at your own risk. In addition, your use of Linked Sites is subject to any applicable policies and terms and conditions of use, including but not limited to, the Linked Site\'s privacy and security policy.',
    goToMarketPlaceBtn: {
      title: 'GO TO THE MARKETPLACE'
    },
    closeBtn: {
      title: 'CLOSE'
    }
  },
  buttons: {
    editInfo: {
      display: true,
      text: 'EDIT INFO'
    },
    viewPlans: {
      display: true,
      text: 'VIEW PLANS'
    },
    planDetails: {
      display: true,
      text: 'PLAN DETAILS'
    },
    compare: {
      display: true,
      text: 'COMPARE'
    },
    edit: {
      display: true,
      text: 'EDIT'
    },
    shopPlans: {
      display: true,
      text: 'SHOP DIRECTLY WITH BCBSWY'
    },
    goBackToFFM: {
      display: true,
      text: 'GO TO THE MARKETPLACE'
    },
    viewResults: {
      display: true,
      text: 'VIEW RESULTS'
    },
    editOnFFM: {
      display: true,
      text: 'GO TO THE MARKETPLACE'
    },
    initialPayment: {
      display: true,
      text: 'MAKE PAYMENT'
    },
    summary: {
      display: true,
      text: 'RETRIEVE'
    },
    moreInfo: {
      display: true,
      text: 'MORE INFO'
    }
  }
};
export const NDOnExchangeStatusTeamsite = {
  heading: 'CUSTOMER SHOPPING STATUS',
  noResultsMessage: 'There are no applications to display.',
  sidebar: {
    header: 'CUSTOMER SHOPPING STATUS',
    subText:
      'Review information about customer application status from the Health Insurance Marketplace.'
  },
  newCustomerStatusMessage:
    'Continue with your application to the Health Insurance Marketplace or Shop Directly with BCBSND.<br><br>Plans purchased directly from BCBSND are not eligible for the Advanced Premium Tax Credit (APTC) and/or Cost-Sharing Reduction (CSR).<br><br>',
  eligibilityMessage:
    'It looks like there is an error in determining your customer\'s Health Insurance Marketplace eligibility. Return to the Health Insurance Marketplace to resolve this issue, or continue to shop directly with BCBSND. <br><br>Plans purchased directly from BCBSND are not eligible for the Advanced Premium Tax Credit (APTC) and/or Cost-Sharing Reduction (CSR).<br><br>',
  userInitiatedReturnMessage:
    'You have returned without completing your customer\'s Health Insurance Marketplace eligibility application.  To continue, select Go To the Marketplace.  Or, you can Shop Directly with BCBSND. <br><br>Plans purchased directly from BCBSND are not eligible for the Advanced Premium Tax Credit (APTC) and/or Cost-Sharing Reduction (CSR).<br><br>',
  EligibilityCompleteMessage:
    'View your customer\'s Health Insurance Marketplace application results to find out if they are eligible for an Advanced Premium Tax Credit (APTC) and/or Cost-Sharing Reduction (CSR) to help with their health insurance costs.<br><br>',
  enrollmentSubmissionFailMessage:
    'We\'re sorry. Enrollment cannot be completed at this time.  In order to proceed, Go To the Health Insurance Marketplace and retrieve eligibility to try again.<br><br>',
  paymentPastDueMessage:
    'No payment was submitted with this online application.<br><br>Information displayed here does not reflect any payment made outside of this online application.<br>Click <b>More Info</b> to see more information and options.</br>',
  paymentPastDueSMABMessage:
    'No payment was submitted with this online application.<br><br>Information displayed here does not reflect any payment made outside of this online application.<br>Click <b>More Info</b> to see more information and options',
  paymentStatusModal: {
    header: 'More Info',
    body:
      'To see if payment has been made and to determine what payment options are available for this plan if payment was not made, contact the Producer Hotline at  1-866-602-1248  (TTY/TDD: 711) Monday thru Friday   8:00 a.m. – 5:00 p.m. EST'
  },
  goToMarketPlaceModal: {
    header: 'YOU ARE ABOUT TO VISIT THE HEALTH INSURANCE MARKETPLACE',
    body:
      'This website contains links to third-party websites and resources (collectively, "Linked Sites").  These Linked Sites are provided solely as a convenience to you and not as an endorsement by BCBSND Inc., or its affiliates and subsidiaries, (collectively, “BCBSND”) of the content on such Linked Sites. Highmark makes no representations or warranties regarding the correctness, accuracy, performance or quality of any content, software, service or application found at any Linked Site. BCBSND is not responsible for the availability of the Linked Sites or the content or activities of such sites. If you decide to access Linked Sites, you do so at your own risk. In addition, your use of Linked Sites is subject to any applicable policies and terms and conditions of use, including but not limited to, the Linked Site\'s privacy and security policy.',
    goToMarketPlaceBtn: {
      title: 'GO TO THE MARKETPLACE'
    },
    closeBtn: {
      title: 'CLOSE'
    }
  },
  buttons: {
    editInfo: {
      display: true,
      text: 'EDIT INFO'
    },
    viewPlans: {
      display: true,
      text: 'VIEW PLANS'
    },
    planDetails: {
      display: true,
      text: 'PLAN DETAILS'
    },
    compare: {
      display: true,
      text: 'COMPARE'
    },
    edit: {
      display: true,
      text: 'EDIT'
    },
    shopPlans: {
      display: true,
      text: 'SHOP DIRECTLY WITH BCBSND'
    },
    goBackToFFM: {
      display: true,
      text: 'GO TO THE MARKETPLACE'
    },
    viewResults: {
      display: true,
      text: 'VIEW RESULTS'
    },
    editOnFFM: {
      display: true,
      text: 'GO TO THE MARKETPLACE'
    },
    initialPayment: {
      display: true,
      text: 'MAKE PAYMENT'
    },
    summary: {
      display: true,
      text: 'RETRIEVE'
    },
    moreInfo: {
      display: true,
      text: 'MORE INFO'
    }
  }
};
